import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateNullDefault, DepositReceived, EmptyString, FormTypeAdd, FormTypeEdit, GuidDefault } from "utils/Constant"
import { ApiDeleteBank, ApiGetBank, ApiGetBookingById, ApiGetBookingRoom, ApiGetBookingTenant, ApiGetPaymentHistory, ApiGetSystemSettingById, ApiInsertBank, ApiInsertBooking, ApiUpdateBank, ApiUpdateBooking } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { money } from "utils/helpers"
import CompleteButton from "components/Button/CompleteButton"

export default function BankForm(){
    const navigate = useNavigate()

    const { fetch: insertBank } = useFetch(ApiInsertBank)
    const { fetch: updateBank } = useFetch(ApiUpdateBank)
    const { fetch: deleteBank } = useFetch(ApiDeleteBank)
    const { fetch: getBank } = useFetch(ApiGetBank)

    const { fetch: insertBooking } = useFetch(ApiInsertBooking)
    const { fetch: updateBooking } = useFetch(ApiUpdateBooking)
    const { fetch: getBookingById } = useFetch(ApiGetBookingById)
    const { fetch: getSystemSetting } = useFetch(ApiGetSystemSettingById)
    const { fetch: getBookingTenant } = useFetch(ApiGetBookingTenant)
    const { fetch: getBookingRoom } = useFetch(ApiGetBookingRoom)
    const { fetch: getPaymentHistory } = useFetch(ApiGetPaymentHistory)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramBookingId = queryString.get("bookingId")
    let paramBankId = queryString.get("bankId")

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [callCenter, setCallCenter] = useState(EmptyString)

    const [paymentHistory, setPaymentHistory] = useState([])
    const [bookingCode, setBookingCode] = useState(EmptyString)
    const [bookingDate, setBookingDate] = useState(EmptyString)
    const [bookingType, setBookingType] = useState(EmptyString)
    const [roomId, setRoomId] = useState(EmptyString)
    const [tenantId, setTenantId] = useState(EmptyString)
    const [checkInDate, setCheckInDate] = useState(EmptyString)
    const [checkOutDate, setCheckOutDate] = useState(EmptyString)
    const [deposit, setDeposit] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [deleteBtnVisible, setDeleteBtnVisible] = useState(true)
    const [tenantOptionDisabled, setTenantOptionDisabled] = useState(false)
    const [bookingDateDisabled, setBookingDateDisabled] = useState(false)
    const [checkInDateDisabled, setCheckInDateDisabled] = useState(false)

    // Dropdown options
    const [tenantOptions, setTenantOptions] = useState([])
    const [roomOptions, setRoomOptions] = useState([])
    const [bookingTypeOptions, setBookingTypeOptions] = useState([])

    // Error
    const [errorTenantId, setErrorTenantId] = useState(false)
    const [errorTenantName, setErrorTenantName] = useState(false)
    const [errorPlaceOfBirth, setErrorPlaceOfBirth] = useState(false)
    const [errorDateOfBirth, setErrorDateOfBirth] = useState(false)

    const [bookingCodeDisabled, setSetBookingCodeDisabled] = useState(true)

    useEffect(() => {
        if (formType === FormTypeEdit){
            setLoading(true)

            fGetBank().then(() => {
                setLoading(false)
            })
        }
    }, [])


    // Function Api Call
    async function fInsertBank(){
        await insertBank({
            data:{
                bankCode: bankCode,
                bankName: bankName, 
                callCenter: callCenter,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/bank") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateBank(){
        await updateBank({
            data:{
                bankId: paramBankId,
                bankCode: bankCode,
                bankName: bankName,
                callCenter: callCenter,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/bank") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    async function fDeleteBank(){
        await deleteBank({
            data:{
                bankId: paramBankId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/bank") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetBank(){
        await getBank({
            data: {
                bankId: paramBankId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setBankCode(data.bankCode)
                setBankName(data.bankName)
                setCallCenter(data.callCenter)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    function fInsertBooking(){
        setLoading(true)
        console.log(checkOutDate)
        insertBooking({
            data:{
                kostId: localStorage.getItem("KostId"),
                kostCode: localStorage.getItem("KostCode"), 
                bookingDate: moment(bookingDate).format("yyyy-MM-DD"),
                bookingType: bookingType,
                roomId: roomId,
                tenantId: tenantId,
                checkInDate: moment(checkInDate).format("yyyy-MM-DD"),
                checkOutDate: checkOutDate === "" || checkOutDate === null ? null : moment(checkOutDate).format("yyyy-MM-DD"),
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/kost/booking") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    function fUpdateBooking(){
        setLoading(true)

        updateBooking({
            data:{
                kostId: localStorage.getItem("KostId"),
                bookingId: paramBookingId,
                checkInDate: moment(checkInDate).format("yyyy-MM-DD"),
                checkOutDate: checkOutDate === "" ? null : moment(checkOutDate).format("yyyy-MM-DD"),
                roomId: roomId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/kost/booking") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    // Function

    function fSaveBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading(true)

            if (formType === FormTypeAdd){
                fInsertBank().then(() => {
                    setLoading(false)
                })
            }else{
                fUpdateBank().then(() => {
                    setLoading(false)
                })
            }
        }}})
    }
    function fDeleteBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading(true)

            fDeleteBank().then(() => {
                setLoading(false)
            })
        }}})
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">Bank Detail</span>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Bank Code */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Bank Code</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ bankCode } onChange={(e) => { setBankCode(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Code is required!</span>
                    </div>
                </div>

                {/* Bank Name */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Bank Name</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ bankName } onChange={(e) => { setBankName(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Name is required!</span>
                    </div>
                </div>

                {/* Call Center */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Call Center</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ callCenter } onChange={(e) => { setCallCenter(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Call Center is required!</span>
                    </div>
                </div>

            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={() => { fSaveBtnClick() }} visible={true} />
                <DeleteButton visible={ formType === FormTypeAdd ? false : true } onClick={() => { fDeleteBtnClick() }} />
                <BackButton onClick={() => { navigate("/bank") }}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}